import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { useFavoritos } from "shared/contexts/Auth/Favoritos/FavoritosContext";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import { Favorito } from "shared/components/favorito/Favorito";
import { IProduto } from "shared/interfaces/IProduto";
import { listarFavoritos } from "shared/services/api/favorito.api";
import styles from "./Favoritos.module.scss";

export const Favoritos: React.FC = () => {
  const { favoritesIds, removeFavorite } = useFavoritos();

  const [produtos, setProdutos] = useState<IProduto[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function carregarFavoritos() {
      try {
        setLoading(true);

        const response = await listarFavoritos();

        setProdutos(response || []);
      } catch (error) {
        console.error(
          "Erro ao carregar favoritos:",
          error
        );

        setProdutos([]);
      } finally {
        setLoading(false);
      }
    }

    carregarFavoritos();
  }, [favoritesIds]);

  return (
    <PageContainer
      title="Meus Favoritos"
      icon={<Heart size={18} />}
    >
      <div className={styles.page}>

        {loading && (
          <p>Carregando favoritos...</p>
        )}

        {!loading && produtos.length === 0 ? (
          <div className={styles.emptyState}>
            <div
              className={styles.containerImgVazio}
            >
              <img
                className={styles.ImgVazio}
                src="/imagens/favoritosVazio.png"
                alt="Favorito vazio"
              />
            </div>

            <p className={styles.fraseVazio}>
              Você não tem
              <br />
              nenhum favorito
            </p>

            <p className={styles.pLink}>
              <a
                href="/"
                className={styles.link}
              >
                Clique aqui
              </a>{" "}
              para ir para a loja
            </p>
          </div>
        ) : (
          produtos.map((produto) => (
            <Favorito
              key={produto.id}
              produto={produto}
              onExcluir={removeFavorite}
            />
          ))
        )}

      </div>
    </PageContainer>
  );
};